function initProjectBoxes(container) {
    const projectBoxes = container.querySelectorAll('.project-box');

    Array.prototype.forEach.call(projectBoxes, box => {
        const projectBoxImages = box.querySelectorAll('.project-box__images div');
        const projectBoxProjects = box.querySelectorAll('.project-box__list .project-box__project a');
    
        if (!document.documentElement.classList.contains('mobile')) {
            Array.prototype.forEach.call(projectBoxProjects, (project, index) => {
                project.addEventListener('mouseover', _ => activateBoxWithIndex(projectBoxProjects, projectBoxImages, index));
            });

            window.addEventListener('resize', _ => {
                if (window.innerWidth >= 800) activateBoxWithIndex(projectBoxProjects, projectBoxImages, 0);
            });
        }
        else {
            let index = 0;
            let projectCount = projectBoxProjects.length;

            setInterval(_ => {
                index++;
                if (index > (projectCount - 1)) index = 0;

                activateBoxWithIndex(projectBoxProjects, projectBoxImages, index);
            }, 3000);
        }
    });


    function activateBoxWithIndex(projectBoxProjects, projectBoxImages, index) {
        for (let i = 0; i < projectBoxProjects.length; i++) {
            if (window.innerWidth >= 800 && i === index) {
                projectBoxImages[i].classList.add('active');
                projectBoxProjects[i].parentElement.classList.add('active');
            }
            else {
                projectBoxImages[i].classList.remove('active');
                projectBoxProjects[i].parentElement.classList.remove('active');
            }
        }
    }
}